<template>
  <Select v-model="user" :placeholder="placeholder" @on-change="change_value">
    <Option
      v-for="(item, index) in options"
      :value="item.value"
      :key="`${index}-${item.value}`"
    >
      {{ item.label }}
    </Option>
  </Select>
</template>

<script>
import { getParams } from "./utils";
export default {
  props: {
    placeholder: {
      type: String,
      default: "请选择选品人"
    },
    data: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      user: 0,
      options: []
    };
  },
  watch: {
    data(val) {
      val.map(o => this.options.push({ value: o.id, label: o.name }));
    }
  },
  methods: {
    change_value(val) {
      let params = getParams("a.fullname", val, "=");
      this.$emit("get", params, Boolean(val));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/basic-filter/BaseXuanp.vue